import EXIF from "exif-js";

const iphone_photo_rotation_adjust = (file) => {
  return new Promise(function (resolve, reject) {
    EXIF.getData(file, function () {
      var orientation = this.exifdata.Orientation;
      // case 1: normal
      // case 2: horizontal flip
      // case 3: 180° rotate left
      // case 4: vertical flip
      // case 5: vertical flip + 90 rotate right
      // case 6: 90° rotate right
      // case 7: horizontal flip + 90 rotate right
      // case 8: 90° rotate left
      // iphone photo has 1 3 6 8

      var data_url = URL.createObjectURL(file);

      var img = document.createElement("img");
      img.src = data_url;

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");

      img.onload = function () {
        var result_width, result_height;
        result_width = img.width;
        result_height = img.height;

        if (orientation === 3) {
          canvas.width = result_width;
          canvas.height = result_height;
          ctx.translate(result_width, result_height);
          ctx.rotate(Math.PI);
        } else {
          canvas.width = result_width;
          canvas.height = result_height;
        }
        ctx.drawImage(img, 0, 0, result_width, result_height);
        const image = canvas.toDataURL("image/jpeg", 0.3);
        console.log(image);
        resolve(image);
      };
      img.onerror = function (error) {
        console.log(error);
      }
      if (img.complete) {
        img.onload();
      }
    });
  });
};

export default iphone_photo_rotation_adjust;
